export const BY_MIN_PRICE = 'BY_MIN_PRICE';
export const BY_MAX_PRICE = 'BY_MAX_PRICE';
